export default __webpack_public_path__ + "static/media/wai_logo.b12c7664.svg";